module.exports = __webpack_public_path__ + "img/bob.14491d35.png";